import React from "react";
import InputWasteWoodForm from "./InputWasteWoodForm";
import { Toast } from "../../utils/Toast";
import { defaultPostBakingWasteWoodInputDetail } from "../../constance/dataTypes";
import { GET, POST, PUT } from "../../utils/HttpClient";
import * as _ from "lodash";
import { useTranslation } from "react-i18next";
import { URL_POST_BAKING } from "../../constance/urls";
import ErrorMessage from "../common/ErrorMessage";
import { Modal, Button, Form } from "antd";
import { CloseOutlined, PlusOutlined, EditOutlined } from "@ant-design/icons";
import ColorButton from "../common/ColorButton";
import { BLUE_COLOR, PRIMARY_COLOR } from "../../constance/color";

export default function WasteWoodModal(props) {
  const {
    transaction,
    open,
    onClose,
    target
  } = props;

  const [form] = Form.useForm();
  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const isCreate = target == 'add';

  const handleSubmit = async (values) => {
    setLoading(true);
    setErrorMessages(null)
    try {
      const validate = await form.validateFields();
      if (isCreate) {
        await POST(URL_POST_BAKING.POST_BAKING_WASTE_WOOD_INPUT, values)
      } else {
        await PUT(`${URL_POST_BAKING.POST_BAKING_WASTE_WOOD_INPUT}${target}/`, values)
      }
      Toast.success(`${t('save')} ${t('success')}`)
      onClose();
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setLoading(false)
    }
  }

  const fetchData = async () => {
    setLoading(true);
    setErrorMessages(null)
    try {
      const response = await GET(`${URL_POST_BAKING.POST_BAKING_WASTE_WOOD_INPUT}${target}/`)
      form.setFieldsValue(response.data)
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => {
    if (open) {
      form.resetFields();
      if (!isCreate) {
        fetchData()
      } else {
        form.setFieldValue('transaction', transaction)
      }
    }
  }, [open])

  return (
    <Modal
      title={isCreate ? t('add') : `${t('edit')} ${t('post_baking_waste_wood_input.detail')}`}
      open={open}
      onCancel={onClose}
      footer={[
        <Button
          color="default"
          variant="filled"
          icon={<CloseOutlined />}
          loading={loading}
          onClick={onClose} >{t('cancel')}</Button>,
        <ColorButton
          type="primary"
          override={isCreate ? PRIMARY_COLOR : BLUE_COLOR}
          icon={isCreate ? <PlusOutlined /> : <EditOutlined />}
          loading={loading}
          onClick={() => handleSubmit(form.getFieldsValue())}  >{isCreate ? t('add') : t('edit')}</ColorButton>
      ]}>
      <ErrorMessage message={errorMessages} />
      <InputWasteWoodForm form={form} handleSubmit={form.submit} />
    </Modal>
  )
}